module.exports = __webpack_public_path__ + "img/1.72caa1cf.jpg";